var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34373 1.03125H9.85989L6.54752 4.81708L10.4443 9.96875H7.39268L5.00293 6.84429L2.26852 9.96875H0.751432L4.29435 5.91937L0.556641 1.03125H3.68477L5.84489 3.88713L8.34373 1.03125ZM7.8116 9.06125H8.65173L3.22872 1.89108H2.32718L7.8116 9.06125Z",
    fill: "#22AD01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterGreen);
export default __webpack_public_path__ + "static/media/twitter-green.def36660e2d7f48baaf7ad9791cdd030.svg";
export { ForwardRef as ReactComponent };